import { useTranslation } from 'react-i18next';
import { ButtonProps } from '../../../../../../shared/library/Button';
import DoneIcon from '@mui/icons-material/Done';
import { StyledButton } from './styles';
import classnames from 'classnames';

export interface AddToBasketButtonProps extends ButtonProps {
  enableAddedToBasketView?: boolean;
  addedToBasketLabel?: string;
}

export default function AddToBasketButton(props: AddToBasketButtonProps) {
  const { t } = useTranslation();
  const {
    enableAddedToBasketView,
    addedToBasketLabel,
    children,
    ...buttonProps
  } = props;

  const buttonLabel =
    children ||
    t(
      'site.pricing.products-selection.primary-product-card.button.add-to-basket.label',
    );
  const buttonAddedLabel = (
    <>
      <DoneIcon />
      {addedToBasketLabel ||
        t(
          'site.pricing.products-selection.primary-product-card.button.added.label',
        )}
    </>
  );
  const buttonClassNames = classnames(
    buttonProps.className,
    'informa-payment-add-to-basket-button',
    {
      'box__basket-submit': buttonProps.type === 'submit', // Don't delete this class. It's for GTM (see GEN-1476)
    },
  );

  return (
    <StyledButton {...buttonProps} className={buttonClassNames}>
      {enableAddedToBasketView ? buttonAddedLabel : buttonLabel}
    </StyledButton>
  );
}
